import { render, staticRenderFns } from "./Otpusks.vue?vue&type=template&id=450514a1&scoped=true&"
import script from "./Otpusks.vue?vue&type=script&lang=js&"
export * from "./Otpusks.vue?vue&type=script&lang=js&"
import style0 from "./Otpusks.vue?vue&type=style&index=0&id=450514a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450514a1",
  null
  
)

export default component.exports